var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,attrs:{"data-animated-illustration":"","viewBox":"0 0 500 500"}},[_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.playing),expression:"playing"}],attrs:{"stroke-width":_vm.strokeWidth,"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }